let activeLocks = 0;
let originalOverflow = '';
let originalOverscroll = [];

export const lockBodyScroll = () => {
  if (activeLocks === 0) {
    originalOverflow = document.body.style.overflow;
    originalOverscroll = [document.documentElement, document.body].map(
      (element) => [element, element.style.overscrollBehaviorY]
    );
  }

  activeLocks += 1;
  document.body.style.overflow = 'hidden';
  originalOverscroll.forEach(([element]) => {
    element.style.overscrollBehaviorY = 'none';
  });
  let released = false;

  return () => {
    if (released) return;

    released = true;
    activeLocks = Math.max(0, activeLocks - 1);

    if (activeLocks === 0) {
      document.body.style.overflow = originalOverflow;
      originalOverflow = '';
      originalOverscroll.forEach(([element, value]) => {
        element.style.overscrollBehaviorY = value;
      });
      originalOverscroll = [];
    }
  };
};
